import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
import { ConfigModule } from 'Angular/config/config.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class SingleSeriesFundChartModule {
}
SingleSeriesFundChartModule.ɵfac = function SingleSeriesFundChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SingleSeriesFundChartModule)(); };
SingleSeriesFundChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleSeriesFundChartModule });
SingleSeriesFundChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        BrowserModule,
        FormsModule,
        IconModule,
        ConfigModule,
        TooltipModule,
        FeatureNeededModule,
        FundamentalChartModule] });
